// extracted by mini-css-extract-plugin
var _1 = "parent-tag___lMLMO";
export { _1 as "parent-tag" }
